import lodash from "lodash";
import _ from "lodash";

// Helper Function to get Error message

export const setPdErrMsg = (temp_state, pageNo, tabNo) => {
    let propAdd = temp_state["Property Address"];
    let propAtt = temp_state["Property Details"]["Property Attributes"];
    let descriptions = temp_state["Property Details"]["descriptionGenerated"];
    let amazingFeat = temp_state["Property Details"]["Amazing features"];
    let tabs = temp_state["Property Details"]["tabs"];

    let errorMessage = "";

    if (pageNo !== null) {
        // Property address
        if (propAdd === "" && pageNo > 0) {
            errorMessage = "Please fill the property address.";
        }

        // Property attributes
        if (errorMessage === "" && pageNo > 1) {
            for (const pat in propAtt) {
                if (
                    errorMessage === "" &&
                    propAtt[pat]["isRequired"] &&
                    (propAtt[pat]["value"] === "" || propAtt[pat]["value"] == 0)
                ) {
                    errorMessage = `${propAtt[pat]["lable"]} is required`;
                }
                if (errorMessage !== "") {
                    break;
                }
            }
        }

        // Amazing features
        if (errorMessage === "" && pageNo > 1) {
            loop1: for (const ft in amazingFeat) {
                loop2: for (const feat in amazingFeat[ft]["features"]) {
                    if (
                        errorMessage === "" &&
                        amazingFeat[ft]["features"][feat]["isRequired"] &&
                        amazingFeat[ft]["features"][feat]["selectedFeatures"] ==
                            ""
                    ) {
                        errorMessage = `${amazingFeat[ft]["features"][feat]["title"]} is required`;
                    }
                    if (errorMessage !== "") {
                        break loop1;
                    }
                }
            }
        }

        // Tabwise features
        if (errorMessage === "" && pageNo > 2) {
            loop1: for (const opt of tabs.tabOptions) {
                loop2: for (const ft in tabs.tabData[opt]) {
                    loop3: for (const feat in tabs.tabData[opt][ft][
                        "features"
                    ]) {
                        if (
                            errorMessage === "" &&
                            tabs.tabData[opt][ft]["features"][feat][
                                "isRequired"
                            ] &&
                            tabs.tabData[opt][ft]["features"][feat][
                                "selectedFeatures"
                            ] == ""
                        ) {
                            errorMessage = `${tabs.tabData[opt][ft]["features"][feat]["title"]} in ${opt} is required`;
                        }
                        if (errorMessage !== "") {
                            break loop1;
                        }
                    }
                }
            }
        }
    }

    if (tabNo !== null) {
        // Tabwise features
        if (errorMessage === "") {
            loop1: for (let i = 0; i < tabNo; i++) {
                let tabName = tabs.tabOptions[i];
                loop2: for (const ft in tabs.tabData[tabName]) {
                    loop3: for (const feat in tabs.tabData[tabName][ft][
                        "features"
                    ]) {
                        if (
                            errorMessage === "" &&
                            tabs.tabData[tabName][ft]["features"][feat][
                                "isRequired"
                            ] &&
                            tabs.tabData[tabName][ft]["features"][feat][
                                "selectedFeatures"
                            ] == ""
                        ) {
                            errorMessage = `${tabs.tabData[tabName][ft]["features"][feat]["title"]} in ${tabName} is required`;
                        }
                        if (errorMessage !== "") {
                            break loop1;
                        }
                    }
                }
            }
        }
    }

    // Description
    if (errorMessage === "" && pageNo > 2) {
        if (descriptions.length === 0) {
            errorMessage = "You have not generated any descriptions yet.";
        }
    }

    return errorMessage;
};

// Helper function to initialise tab data
export const initializeTabData = (tabObj, propFeat, genFeat) => {
    let locatedOnGfInd = -1;
    propFeat.primaryBedroom.features[
        "Bedroom Features"
    ].preDeterminedFeatures.forEach((feat, i) => {
        if (feat.featureName === "located on ground floor") {
            locatedOnGfInd = i;
        }
    });
    if (tabObj.tabOptions[0] !== "Home interior") {
        if (locatedOnGfInd != -1) {
            propFeat.primaryBedroom.features[
                "Bedroom Features"
            ].preDeterminedFeatures.splice(locatedOnGfInd, 1);
        }
    } else {
        if (locatedOnGfInd == -1) {
            propFeat.primaryBedroom.features[
                "Bedroom Features"
            ].preDeterminedFeatures.push({
                featureName: "located on ground floor",
                isSelected: false,
            });
        }
    }

    tabObj.tabOptions.forEach((opt, i) => {
        if (!tabObj.tabData[opt]) {
            if (i < tabObj.tabOptions.length - 1) {
                tabObj.tabData[opt] = lodash.cloneDeep(propFeat);
            } else {
                tabObj.tabData[opt] = lodash.cloneDeep(genFeat);
            }
        }
    });
};

// Function to form body

export const pdFormBody = ({ propState, userDetails }) => {
    const bodyobj = {
        order_id: propState["order_id"],
        prompt_type: "property_description",
        form_schema: {},
        name: userDetails?.name || "",
        email: userDetails?.email || "",
    };

    // Property address
    if (propState["Property Address"] !== "") {
        bodyobj.form_schema["Property Address"] = propState["Property Address"];
    }

    // Property type
    if (propState["Property Details"]["Property type"]["selectedItem"] !== "") {
        bodyobj.form_schema["Property type"] =
            propState["Property Details"]["Property type"]["selectedItem"];
    }

    // Nearby amenities
    let selectedAmenities = {};
    Object.keys(propState["Nearby Amenities"]).forEach((ammobj, i) => {
        Object.keys(propState["Nearby Amenities"][ammobj]).forEach((amm, j) => {
            if (propState["Nearby Amenities"][ammobj][amm]["isSelected"]) {
                if (!selectedAmenities[ammobj]) {
                    selectedAmenities[ammobj] = [];
                }
                selectedAmenities[ammobj].push(amm);
            }
        });
    });

    if (!_.isEmpty(selectedAmenities)) {
        bodyobj.form_schema["Nearby Amenities"] = { ...selectedAmenities };
    }

    // Property attributes
    Object.keys(propState["Property Details"]["Property Attributes"]).forEach(
        (pa, i) => {
            let paObj =
                propState["Property Details"]["Property Attributes"][pa];
            if (paObj["value"] !== "" && paObj["value"] != 0) {
                if (pa === "Garage") {
                    bodyobj.form_schema[pa] = `${paObj["value"]}`;
                    if (paObj["unit"]) {
                        bodyobj.form_schema["Garage_type"] = `${paObj["unit"]}`;
                    }
                } else if (paObj["unit"]) {
                    bodyobj.form_schema[
                        pa
                    ] = `${paObj["value"]} ${paObj["unit"]}`;
                } else {
                    bodyobj.form_schema[pa] = `${paObj["value"]}`;
                }
            }
        }
    );

    // Design Type
    // bodyobj.form_schema["Design type"] =
    //     propState["Property Details"]["Design type"]["selectedItem"];

    // Amazing features
    for (const key in propState["Property Details"]["Amazing features"]) {
        for (const data in propState["Property Details"]["Amazing features"][
            key
        ].features) {
            if (
                propState["Property Details"]["Amazing features"][key].features[
                    data
                ]["selectedFeatures"] !== ""
            ) {
                if (!bodyobj.form_schema["Amazing features"]) {
                    bodyobj.form_schema["Amazing features"] = {};
                }
                if (!bodyobj.form_schema["Amazing features"][key]) {
                    bodyobj.form_schema["Amazing features"][key] = {};
                }

                if (!bodyobj.form_schema["Amazing features"][key][data]) {
                    bodyobj.form_schema["Amazing features"][key][data] = {};
                }

                bodyobj.form_schema["Amazing features"][key][data] =
                    propState["Property Details"]["Amazing features"][
                        key
                    ].features[data]["selectedFeatures"];
            }
        }
    }

    // Description Type
    bodyobj.form_schema["descriptionType"] =
        propState["Property Details"]?.descriptionType?.selectedDescType;

    // Property features Tab wise
    propState["Property Details"]?.tabs?.tabOptions.forEach((tab) => {
        for (const data in propState["Property Details"]?.tabs?.tabData[tab]) {
            for (const feat in propState["Property Details"]?.tabs?.tabData[
                tab
            ][data].features) {
                if (
                    propState["Property Details"]?.tabs?.tabData[tab][data]
                        .features[feat].selectedFeatures !== ""
                ) {
                    if (!bodyobj.form_schema["Property features"]) {
                        bodyobj.form_schema["Property features"] = {};
                    }

                    if (!bodyobj.form_schema["Property features"][`${tab}`]) {
                        bodyobj.form_schema["Property features"][`${tab}`] = {};
                    }

                    if (!bodyobj.form_schema["Property features"][tab][data]) {
                        bodyobj.form_schema["Property features"][tab][data] =
                            {};
                    }

                    if (
                        !bodyobj.form_schema["Property features"][tab][data][
                            feat
                        ]
                    ) {
                        bodyobj.form_schema["Property features"][tab][data][
                            feat
                        ] = {};
                    }

                    bodyobj.form_schema["Property features"][tab][data][feat] =
                        propState["Property Details"]?.tabs?.tabData[tab][
                            data
                        ].features[feat].selectedFeatures;
                }
            }
        }
    });

    return bodyobj;
};

export const repopulate = (temp_state, data) => {
    histDynFeat(temp_state);
    temp_state.order_id = data.order_id;
    let form_schema = data?.form_schema;

    if (form_schema["Property Address"]) {
        temp_state["Property Address"] = form_schema["Property Address"];
    }

    // Nearby amenities
    if (form_schema["Nearby Amenities"]) {
        Object.keys(form_schema["Nearby Amenities"]).forEach((ammkey, i) => {
            temp_state["Nearby Amenities"][ammkey] = {};
            form_schema["Nearby Amenities"][ammkey].forEach((amm, j) => {
                temp_state["Nearby Amenities"][ammkey][amm] = {
                    isSelected: true,
                };
            });
        });
    }

    if (form_schema["Property type"]) {
        temp_state["Property Details"]["Property type"].title =
            form_schema["Property type"];
        temp_state["Property Details"]["Property type"].selectedItem =
            form_schema["Property type"];
    }
    if (form_schema["Design type"]) {
        temp_state["Property Details"]["Design type"].title =
            form_schema["Design type"];
        temp_state["Property Details"]["Design type"].selectedItem =
            form_schema["Design type"];
    }

    // Property attributes
    Object.keys(temp_state["Property Details"]["Property Attributes"]).forEach(
        (pa, i) => {
            let paObj =
                temp_state["Property Details"]["Property Attributes"][pa];
            if (form_schema[pa]) {
                paObj["value"] = form_schema[pa].includes(" Sq Feet")
                    ? form_schema[pa].replace(" Sq Feet", "")
                    : form_schema[pa];
                if (paObj["inputType"] === "dropDown") {
                    paObj["ddObj"]["title"] = paObj["ddObj"]["selectedItem"] =
                        form_schema[pa].includes(" Sq Feet")
                            ? form_schema[pa].replace(" Sq Feet", "")
                            : form_schema[pa];
                }
                if (
                    paObj["isDropdownAvailable"] &&
                    form_schema["Garage_type"]
                ) {
                    paObj["dropdownContent"][form_schema["Garage_type"]][
                        "isSelected"
                    ] = true;
                    paObj["unit"] = form_schema["Garage_type"];
                }
            }
        }
    );

    // Design Type
    // bodyobj.form_schema["Design type"] =
    //     propState["Property Details"]["Design type"]["selectedItem"];

    // Amazing features
    if (form_schema["Amazing features"]) {
        for (const key in form_schema["Amazing features"]) {
            for (const data in form_schema["Amazing features"][key]) {
                let featobj =
                    temp_state["Property Details"]["Amazing features"][key][
                        "features"
                    ][data];
                featobj["selectedFeatures"] =
                    form_schema["Amazing features"][key][data];
                featobj["selectedFeatures"].split(",").forEach((ft) => {
                    featobj["preDeterminedFeatures"].forEach((obj) => {
                        if (obj["featureName"] === ft.trim()) {
                            obj["isSelected"] = true;
                        }
                    });
                });
            }
        }
    }

    // Description Type
    if (form_schema["descriptionType"]) {
        temp_state["Property Details"].descriptionType.selectedDescType =
            form_schema["descriptionType"];
    }

    // Property features Tab wise
    if (form_schema["Property features"]) {
        temp_state["Property Details"]["tabs"]["tabOptions"] = [];
        for (const tab in form_schema["Property features"]) {
            temp_state["Property Details"]["tabs"]["tabOptions"].push(tab);
            if (tab === "General features") {
                temp_state["Property Details"]["tabs"]["tabData"][tab] =
                    lodash.cloneDeep(
                        temp_state["Property Details"]["General features"]
                    );
            } else {
                temp_state["Property Details"]["tabs"]["tabData"][tab] =
                    lodash.cloneDeep(
                        temp_state["Property Details"]["Property features"]
                    );
            }
            for (const key in form_schema["Property features"][tab]) {
                for (const data in form_schema["Property features"][tab][key]) {
                    let featobj =
                        temp_state["Property Details"]["tabs"]["tabData"][tab][
                            key
                        ]["features"][data];
                    featobj["selectedFeatures"] =
                        form_schema["Property features"][tab][key][data];

                    featobj["selectedFeatures"].split(",").forEach((ft) => {
                        featobj["preDeterminedFeatures"].forEach((obj) => {
                            if (obj["featureName"] === ft.trim()) {
                                obj["isSelected"] = true;
                            }
                        });
                    });
                }
            }
        }
    }

    for (const ft in data.form_schema["Property features"]) {
        if (
            data.form_schema["Property features"][ft]["primaryBedroom"] &&
            data.form_schema["Property features"][ft]["primaryBedroom"][
                "Bedroom Features"
            ] &&
            !data.form_schema["Property features"][ft]["primaryBedroom"][
                "Bedroom Features"
            ].includes("en-suite bathroom")
        ) {
            if (
                temp_state["Property Details"]["tabs"]["tabData"][ft][
                    "primaryBedroom"
                ] &&
                temp_state["Property Details"]["tabs"]["tabData"][ft][
                    "primaryBedroom"
                ]["features"]["Bedroom Features"]
            ) {
                delete temp_state["Property Details"]["tabs"]["tabData"][ft][
                    "primaryBedroom"
                ]["features"]["Bathroom Features"];
            }
        }
    }

    temp_state["Property Details"]["tabs"]["activeTab"] =
        temp_state["Property Details"]["tabs"]["tabOptions"][0];

    temp_state.pageType.activePage = "Generated Section";
    temp_state.stepper.steps.forEach((step, i) => {
        step.active = i === temp_state.stepper.steps.length - 1 ? true : false;
        step.completed = true;
    });
    temp_state.repopulate = true;
    temp_state["Property Details"].descriptionGenerated = PdFormat(
        data?.descriptions
    );
};

const histDynFeat = (temp_state) => {
    temp_state["Property Details"]["Property features"]["primaryBedroom"][
        "features"
    ]["Bathroom Features"] = {
        title: "The en-suite bath has features like",
        preDeterminedFeatures: [
            {
                featureName: "recently upgraded",
                isSelected: false,
            },
            {
                featureName: "granite countertop",
                isSelected: false,
            },
            {
                featureName: "modern vanity",
                isSelected: false,
            },
            {
                featureName: "double sink",
                isSelected: false,
            },
            {
                featureName: "built-in shelving",
                isSelected: false,
            },
            {
                featureName: "sauna",
                isSelected: false,
            },
            {
                featureName: "rain showerhead",
                isSelected: false,
            },
            {
                featureName: "glass door",
                isSelected: false,
            },
            {
                featureName: "marble floor",
                isSelected: false,
            },
            {
                featureName: "radiant floor heating",
                isSelected: false,
            },
        ],
        selectedFeatures: "",
        isRequired: false,
    };
};

export const dynamicFeat = (temp_state) => {
    temp_state["Property Details"].tabs.tabOptions.forEach((tab, i, arr) => {
        if (i < arr.length - 1) {
            let primaryBedroomFeats =
                temp_state["Property Details"].tabs.tabData[tab].primaryBedroom
                    .features;
            if (
                primaryBedroomFeats["Bedroom Features"][
                    "selectedFeatures"
                ].includes("en-suite bathroom")
            ) {
                if (!primaryBedroomFeats["Bathroom Features"]) {
                    primaryBedroomFeats["Bathroom Features"] = {
                        title: "The en-suite bath has features like",
                        preDeterminedFeatures: [
                            {
                                featureName: "recently upgraded",
                                isSelected: false,
                            },
                            {
                                featureName: "granite countertop",
                                isSelected: false,
                            },
                            {
                                featureName: "modern vanity",
                                isSelected: false,
                            },
                            {
                                featureName: "double sink",
                                isSelected: false,
                            },
                            {
                                featureName: "built-in shelving",
                                isSelected: false,
                            },
                            {
                                featureName: "sauna",
                                isSelected: false,
                            },
                            {
                                featureName: "rain showerhead",
                                isSelected: false,
                            },
                            {
                                featureName: "glass door",
                                isSelected: false,
                            },
                            {
                                featureName: "marble floor",
                                isSelected: false,
                            },
                            {
                                featureName: "radiant floor heating",
                                isSelected: false,
                            },
                        ],
                        selectedFeatures: "",
                        isRequired: false,
                    };
                }
            } else {
                delete primaryBedroomFeats["Bathroom Features"];
            }
        }
    });
};

// Helper fuction to check action response

export const checkActRes = (res, action) => {
    let descObj = res?.data[action.payload.descInd];
    if (res?.status !== "success") {
        return false;
    }
    if (res?.data.length === 0) {
        return false;
    }
    if (descObj["gen_id"] !== action.payload.gen_id) {
        return false;
    }
    Object.keys(action.payload.actionInfo).forEach((actKey) => {
        if (descObj[actKey] !== action.payload.actionInfo[actKey]) {
            return false;
        }
    });

    return true;
};

// Helper function for formatting response

export const PdFormat = (responseArr) => {
    return responseArr.map((resObj, i) => {
        // reducer description schema
        return {
            status: "Just now",
            description_generated: resObj?.description_generated || "",
            editedDesc: resObj?.description_generated || "",
            isEditing: false,
            isEdited: resObj?.is_edited || false,
            like_status: resObj?.like_status,
            generated_at: resObj?.updatedAt || "",
            gen_id: resObj.gen_id,
            rewrite_count: resObj?.rewrite_count || 0,
        };
    });
};
